import { ToasterType } from "../components/shared/toaster/toaster.model";
import Config from "../config";
import setToast from "../helpers/toaster.helper";
import { FileService } from "../services/FileService";
import { MessageLogSevice } from "../services/messageLogService";
import { mapToMediaModel } from "./conversations";
import { MediaModel } from "./reports.model";

export class MessageLogsModel {
    constructor() { }

    FromNumber: string[];
    ToNumber: string[];
    SentBy: string;
    DeliveryStatus: number;
    Direction: number;
    Message: string;
    TimeStamp: string;
    Media: MediaModel[];
    IsDeleted: boolean;
    PartationKey: string;
    MessageType: number;
    TotalMessageLogs: number
}


export const mapToMessageLogs = (x: any): MessageLogsModel => {
    return {
        FromNumber: x.from.split(','),
        ToNumber: x.to.split(','),
        SentBy: x.sentBy,
        DeliveryStatus: x.deliveryStatus,
        Direction: x.direction,
        Message: x.message,
        TimeStamp: x.timeStamp,
        Media: x.media ? x?.media.map(mapToMediaModel) : null,
        IsDeleted: x.isDeleted,
        PartationKey: x.partationKey,
        MessageType: x.messageType,
        TotalMessageLogs: x.totalMessageLogs
    }
}

export const messageLogDownLoad = (msg) => {
    if (msg === "Message Logs Zip file preparation started") {
        return true
    }
    else {
        FileService.downLoadFile(msg).then((response) => {
            const url = URL.createObjectURL(new Blob([response.data], { type: "application/zip" }));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "Messagelog.zip");
            link.click();
            MessageLogSevice.deleteMessagwlogReportfromDb(msg)
                .then((res) => {
                }).catch((err) => { return false })
            setToast(`Message logs downloaded successfully. You can check it!`, ToasterType.SUCCESS)
            return false
        }).catch((err) => {
            return false
        })
    }
}

export const mapToSecureChatMessageLogs = (x: any) => {
    return {
        FromNumber: x.from,
        ToNumber: x.to,
        SentBy: x.sentBy,
        DeliveryStatus: x.deliveryStatus,
        Direction: x.direction,
        Message: x.message,
        TimeStamp: x.timeStamp,
        Media: x.media ? x?.media : null,
        TotalMessageLogs: x.totalMessageLogs
    }
}
